import { render } from "./ContractDetail.vue?vue&type=template&id=1c927d67&scoped=true"
import script from "./ContractDetail.vue?vue&type=script&lang=js"
export * from "./ContractDetail.vue?vue&type=script&lang=js"

import "./ContractDetail.vue?vue&type=style&index=0&id=1c927d67&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c927d67"],['__file',"src/views/h5/crm/contract/ContractDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c927d67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c927d67', __exports__)) {
    api.reload('1c927d67', __exports__)
  }
  
  module.hot.accept("./ContractDetail.vue?vue&type=template&id=1c927d67&scoped=true", () => {
    api.rerender('1c927d67', render)
  })

}


export default __exports__